const blogs = [
  {
    id: 1,
    date: "2024-06-17",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Como Aproveitar os Bônus do 552bet Durante as Festas",
    descr:
      "Descubra como maximizar seus ganhos utilizando os bônus especiais de Natal e Ano Novo oferecidos no 552bet.",
    fullText:
      "Os bônus de Natal e Ano Novo do 552bet são uma excelente oportunidade para jogadores aproveitarem prêmios extras. \n\nPara começar, basta realizar seu cadastro e fazer o primeiro depósito. Bônus exclusivos serão ativados automaticamente para que você jogue mais sem precisar gastar muito. \n\nDurante as festas, o 552bet oferece rodadas grátis em slots temáticos, onde os multiplicadores especiais garantem ainda mais diversão. \n\nOutra promoção é o sorteio de prêmios de Ano Novo para quem faz depósitos frequentes. Cada depósito qualificado aumenta suas chances de ganhar. \n\nAlém disso, não deixe de conferir as condições de uso dos bônus. Entender como eles funcionam pode maximizar suas apostas e seus ganhos. \n\nJogar com responsabilidade também é importante para aproveitar ao máximo os bônus sem perder o controle do orçamento. \n\nPor fim, fique atento às atualizações diárias do 552bet. Novas promoções e surpresas são lançadas ao longo das festas. \n\nCom essas dicas, você estará pronto para fazer de suas apostas um verdadeiro presente de fim de ano!",
  },
  {
    id: 2,
    date: "2024-06-18",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Fortune Tiger: Guia Completo para Multiplicar Seus Ganhos",
    descr:
      "Aprenda a jogar o Fortune Tiger no 552bet e conquiste os melhores multiplicadores do jogo.",
    fullText:
      "O Fortune Tiger é um dos jogos mais populares no 552bet, conhecido por sua simplicidade e potencial de ganhos altos. \n\nNeste jogo, cada rodada oferece a chance de desbloquear multiplicadores que podem chegar a 10x o valor apostado. \n\nPara jogar, o primeiro passo é definir o valor da aposta. Em seguida, basta girar e torcer para que os símbolos especiais ativem as rodadas de bônus. \n\nDurante as festas, o Fortune Tiger ganha novas animações temáticas com prêmios extras para os jogadores cadastrados. \n\nUma estratégia eficiente é definir um orçamento diário e jogar com apostas equilibradas. Isso aumenta suas chances de aproveitar mais rodadas. \n\nNão se esqueça de resgatar os bônus especiais do 552bet que oferecem rodadas grátis no Fortune Tiger. \n\nCom rodadas de bônus e multiplicadores especiais, o Fortune Tiger pode ser a chave para grandes vitórias durante as festas. \n\nAproveite o tema vibrante do jogo e a sorte do tigre para fazer suas apostas mais emocionantes!",
  },
  {
    id: 3,
    date: "2024-06-19",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Estratégias para o Aviator: Como Apostar com Inteligência",
    descr:
      "Domine o Aviator no 552bet com nossas dicas e estratégias para multiplicar seus ganhos.",
    fullText:
      "O Aviator é um jogo dinâmico e emocionante no 552bet que testa a paciência e estratégia dos jogadores. \n\nO objetivo é simples: acompanhar o multiplicador e resgatar seus ganhos antes que o avião desapareça. \n\nUma das melhores estratégias é começar com apostas baixas e aumentar gradualmente conforme você se familiariza com o ritmo do jogo. \n\nOutro truque é utilizar os bônus especiais do 552bet durante as festas. Bônus de Natal e Ano Novo permitem jogar mais sem gastar do seu saldo. \n\nObservar o histórico de rodadas também é uma tática inteligente. Ele pode ajudar a identificar padrões e decidir quando resgatar seus ganhos. \n\nAlém disso, definir limites de apostas e ganhos é essencial para manter um jogo responsável. \n\nCom o Aviator, o segredo está no equilíbrio entre ousadia e cautela. Resgatar cedo garante ganhos constantes, enquanto arriscar pode trazer prêmios maiores. \n\nJogue com sabedoria e aproveite ao máximo as promoções especiais do 552bet durante as festas!",
  },
  {
    id: 4,
    date: "2024-06-20",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Top 5 Jogos para Aproveitar no 552bet Neste Natal",
    descr:
      "Conheça os jogos mais populares do 552bet que vão deixar suas festas ainda mais emocionantes!",
    fullText:
      "O 552bet selecionou os 5 jogos mais emocionantes para você aproveitar durante o Natal e Ano Novo. \n\n1. **Fortune Tiger**: Um jogo vibrante com multiplicadores altos e rodadas bônus festivas. \n2. **Aviator**: Alce voo e resgate ganhos impressionantes antes do avião desaparecer. \n3. **Slots de Natal**: Rodadas grátis e prêmios especiais em slots temáticos. \n4. **Roleta Festiva**: Aposte em rodadas emocionantes com temática de festas. \n5. **Blackjack Premium**: Teste suas habilidades e vença a banca com bônus exclusivos. \n\nCada jogo oferece b\u00f4nus especiais e prêmios que tornam as festas ainda mais divertidas. \n\nAproveite os bônus de boas-vindas, as promoções diárias e as surpresas que o Papai Noel preparou para você. \n\nEscolha o seu jogo favorito e aproveite todas as vantagens do 552bet neste fim de ano!",
  },
  {
    id: 5,
    date: "2024-06-21",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Como Participar das Promoções de Ano Novo no 552bet",
    descr:
      "Saiba como participar das promoções exclusivas de Ano Novo e ganhar prêmios incríveis no 552bet.",
    fullText:
      "As promoções de Ano Novo do 552bet estão repletas de surpresas e prêmios para todos os jogadores. \n\nPara participar, basta realizar depósitos qualificados durante o período da promoção. Cada depósito aumenta suas chances de ganhar. \n\nAlém disso, os jogadores podem desbloquear rodadas grátis em slots especiais e bônus de cashback para apostas perdidas. \n\nOs sorteios de Ano Novo oferecem prêmios em dinheiro, rodadas extras e presentes exclusivos do Papai Noel. \n\nFique atento às notificações no site do 552bet para não perder nenhuma novidade. \n\nPara aproveitar ao máximo, jogue com responsabilidade e defina limites diários para suas apostas. \n\nO Ano Novo é a oportunidade perfeita para começar com sorte e garantir prêmios incríveis no 552bet. \n\nNão deixe de participar das promoções e celebrar suas vitórias neste fim de ano!",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);
});
